import LocationsPage from './locationsPage.js'

export default LocationsPage
